import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Board/dates/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD_ITEM = NAMESPACE + 'ADD_ITEM'
export const ADD_ITEM_ARRAY = NAMESPACE + 'ADD_ITEM_ARRAY'
export const REMOVE_ITEM = NAMESPACE + 'REMOVE_ITEM'
export const SET_ITEM = NAMESPACE + 'SET_ITEM'
export const SET_START = NAMESPACE + 'SET_START'
export const SET_END = NAMESPACE + 'SET_END'

const defaultBoardState = {
  ids: [],
  byId: {},
  isLoading: false,
  isLoaded: false,
  start: null,
  end: null
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case SET_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded,
        }
      } : state
    case ADD_ITEM:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          ids: addUniqueValueToArray({
            array: state[action.payload.boardId].ids,
            value: action.payload.date.id,
            index: action.payload.date.index
          }),
          byId: {
            ...state[action.payload.boardId].byId,
            [action.payload.date.id]: {
              ...action.payload.date
            }
          }
        }
      } : state
    case ADD_ITEM_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          ids: [ ...state[action.payload.boardId].ids ],
          byId: { ...state[action.payload.boardId].byId }
        }
      }

      action.payload.array.forEach(item => {
        newState[action.payload.boardId].ids = addUniqueValueToArray({
          array: newState[action.payload.boardId].ids,
          value: item.id,
          index: item.index
        })
        newState[action.payload.boardId].byId[item.id] = {
          ...item
        }
      })

      return newState
    }
    case REMOVE_ITEM: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          ids: state[action.payload.boardId].ids.filter(id => id !== action.payload.dateId),
          byId: { ...state[action.payload.boardId].byId }
        }
      }

      delete newState[action.payload.boardId].byId[action.payload.dateId]

      return newState
    }
    case SET_ITEM:
      return state[action.payload.boardId] && state[action.payload.boardId].byId[action.payload.date.id] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          byId: {
            ...state[action.payload.boardId].byId,
            [action.payload.date.id]: {
              ...state[action.payload.boardId].byId[action.payload.date.id],
              ...action.payload.date
            }
          }
        }
      } : state
    case SET_START:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          start: action.payload.start
        }
      } : state
    case SET_END:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          end: action.payload.end
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ boardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      boardId,
      isLoading,
      isLoaded
    }
  }
}

export function addItem ({ boardId, date }) {
  return {
    type: ADD_ITEM,
    payload: {
      boardId,
      date
    }
  }
}

export function addItemArray ({ boardId, array }) {
  return {
    type: ADD_ITEM_ARRAY,
    payload: {
      boardId,
      array
    }
  }
}

export function removeItem ({ boardId, dateId }) {
  return {
    type: REMOVE_ITEM,
    payload: {
      boardId,
      dateId
    }
  }
}

export function setItem ({ boardId, date }) {
  return {
    type: SET_ITEM,
    payload: {
      boardId,
      date
    }
  }
}

export function setStart ({ boardId, start }) {
  return {
    type: SET_START,
    payload: {
      boardId,
      start
    }
  }
}

export function setEnd ({ boardId, end }) {
  return {
    type: SET_END,
    payload: {
      boardId,
      end
    }
  }
}
